"use strict";

const { assign } = require("xstate");

const DEFAULT_CONTEXT = {
    error: undefined,
    data: undefined,
    count: undefined,
    limit: 10,
    offset: 0,
    form: undefined,
    previous_state: undefined,
    dialog_form: undefined,
    dialog_form_error: undefined,
    message: undefined,
    number_of_requests_exceeded: undefined,
    number_of_txt_email_exceeded: undefined
};

// function _onSearchAction  (context, event, payload) {
//     let offset = context.offset;
//     if (payload.current_page) {
//         offset = (payload.current_page - 1) * context.limit;
//         delete payload.current_page;
//     }
//
//     return Object.freeze({
//         form: payload,
//         offset: offset
//     });
// }

const events = {
    OPEN_TXT_FILE_DIALOG: {
        target: "show_dialog",
        actions: assign(function ({context, event, meta}) {
            context.previous_state = event.payload.previous_state;
            return context;
        }),
        guard: function ({ context, event }, params) {
            return context.number_of_txt_email_exceeded !== true;
        }
    }
}

const dialog_state = {
    initial: "ready",
    exit: ["closeDialog"],
    "actions": ["onCloseDialog"],
    description: "This is a child state with their own states and events. By exiting, when the dialog is open and receives the the CLOSE event, go back to `ready` if the dialog was opened with the search usable (ready, or the results/error of a search: those leave on the first keystroke, so the mandatory fields are still filled), otherwise to `idle`.",
    on: {
        CLOSE: [
            {
                target: "ready",
                "actions": ["onCloseDialog"],
                guard: function ({ context, event }, params) {
                    // `ready`, not back to show_records/error: it keeps the results on
                    // screen (only `searching` hides them) and runs renderMessage
                    return ["ready", "show_records", "error"].includes(context.previous_state);
                }
            },
            {
                target: "idle",
                "actions": ["onCloseDialog"]
            }
        ]
    },
    states: {

        ready: {
            entry: ["openDialog"],
            on: {
                SEND_TXT_EMAIL: {
                    target: "sending"
                },

            }
        },
        sending: {
            entry: ["clearDialogErrors", "sendTxtEmail"],
            on: {
                // SUCCESS: { target: "success" },
                ERROR: {
                    "target": "error",
                    "actions": ["onSendingTxtError"]
                },
            },
        },
        // success: {
        //     type: 'final',
        // },
        error: {
            "entry": ["renderDialogErrors"],
            on: {
                SEND_TXT_EMAIL: {
                    target: "sending"
                },
            },
        },
    }
};

module.exports = {
    id: "bicsearch",
    initial: "idle",
    context: function ({input}) {
        return Object.assign(DEFAULT_CONTEXT, input);
    },
    states: {

        idle: {
            entry: ["idleOnEntry", "renderMessage"],
            on: {
                CHECK_REQUIRED_FIELDS: {
                    target: "checking_required_fields"
                },
                OPEN_TXT_FILE_DIALOG: events.OPEN_TXT_FILE_DIALOG
            }
        },

        ready: {
            entry: ["readyOnEntry", "renderMessage"],
            on: {
                OPEN_TXT_FILE_DIALOG: events.OPEN_TXT_FILE_DIALOG,
                SEARCH: {
                    target: "searching"
                },
                CHECK_REQUIRED_FIELDS: {
                    target: "checking_required_fields"
                },
                GET_CAPTCHA: {
                    target: "getting_captcha"
                },

            }
        },

        getting_captcha: {
            entry: ["gettingCaptchaOnEntry"],
            exit: ["renderCaptcha"],
            on: {
                SUCCESS: {
                    target: "ready",
                    actions: ["onGettingCaptchaSuccess"]
                },
                // a failed challenge fetch must not strand the page: without this
                // transition the machine accepted nothing while the Search button
                // stayed enabled (every async action ends in an event its state handles)
                ERROR: {
                    target: "ready",
                    actions: ["onGettingCaptchaError"]
                }
            }
        },
        checking_required_fields: {
            entry: ["onCheckRequiredField", "toggleRequirementOnField"],
            on: {
                READY: {
                    target: "ready"
                },
                NOT_READY: {
                    target: "idle"
                },
            }
        },
        searching: {
            entry: ["clearError", "onSearchTransition", "searchingOnEntry"],
            on: {
                SUCCESS: {
                    target: "show_records",
                    actions: ["onSearchingSuccess"]
                },
                ERROR: {
                    target: "error",
                    actions: ["onSearchingError"]
                },
                FINAL_ERROR: {
                    target: "final_error",
                    actions: ["onSearchingError", "onSearchLimitReached"]
                }
            },
        },
        show_records: {
            on: {
                OPEN_TXT_FILE_DIALOG: events.OPEN_TXT_FILE_DIALOG,
                SEARCH: {
                    target: "searching"
                },
                CHECK_REQUIRED_FIELDS: {
                    target: "checking_required_fields"
                }
            }
        },
        error: {
            on: {
                OPEN_TXT_FILE_DIALOG: events.OPEN_TXT_FILE_DIALOG,
                SEARCH: {
                    target: "searching"
                },
                GET_CAPTCHA: {
                    target: "getting_captcha"
                },
                CHECK_REQUIRED_FIELDS: {
                    target: "checking_required_fields"
                }
            }
        },
        final_error: {
            "description": "No more search are allowed. The user can only send txt email or download pdf file, if there is still any available.",
            on: {
                OPEN_TXT_FILE_DIALOG: events.OPEN_TXT_FILE_DIALOG
            }
        },
        // child state
        show_dialog: dialog_state,
        // hist: {
        //     type: 'history',
        //     history: 'shallow' // or 'deep' for nested states
        // },
    },
    actions: {
        onSearchTransition: assign(function ({context, event}) {
            const payload = event.payload;
            let offset;
            if (payload.current_page) {
                offset = (payload.current_page - 1) * context.limit;
                delete payload.current_page;
            } else {
                offset = 0;
            }

            context.form = payload;
            context.offset = offset;
            // the dialog's close message is shown until the next search: renderMessage
            // runs on every idle/ready entry, i.e. on every form keystroke
            context.message = undefined;
            return context;
        }),
        onCheckRequiredField: assign(function ({context, event}) {
            context.form = event.payload.form;
            return context;
        }),
        onGettingCaptchaSuccess: assign(function ({context, event}) {
            const payload = event.payload;
            context.captcha = payload.captcha;
            context.data = undefined;
            return context;
        }),
        onGettingCaptchaError: assign(function ({context, event}) {
            // the previous challenge stays on screen (renderCaptcha skips an
            // undefined one); the banner is rendered by `ready`'s renderMessage and
            // cleared by the next search, like the dialog's close message
            context.message = {
                type: "warning",
                text: event.payload.message
            };
            return context;
        }),
        onSearchingSuccess: assign(function ({context, event}) {

            const payload = event.payload;
            context.data = payload.data;
            context.count = payload.count;
            context.limit = payload.limit;
            context.offset = payload.offset;
            return context;
        }),
        onCloseDialog: assign(function ({context, event}) {
            const payload = event.payload;
            if (payload?.message) {
                context.message = payload.message;
            }
            return context;
        }),
        onSearchingError: assign(function ({context, event}) {

            const payload = event.payload;
            const data = payload.name && payload.name === "no_records_found" ? [] : undefined;
            context.error = {
                name: payload.name,
                fields: payload.fields,
                message: payload.message
            };
            context.captcha = payload.captcha;
            context.data = data;
            context.count = 0;

            return context;
        }),
        onSearchLimitReached: assign(function ({context}) {
            // readyOnEntry reads it: the search stays disabled for the rest of the page
            context.number_of_requests_exceeded = true;
            return context;
        }),
        onSendingTxtError: assign(function ({context, event}) {

            const payload = event.payload;
            context.dialog_form_error = {
                name: payload.name,
                fields: payload.fields,
                message: payload.message
            };
            return context;
        }),

    }
};
